export const iofc = {
  _root: "/iofc"
};
